import React from "react";
import { IconProps } from "react-bootstrap-icons";
import { NavLink, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { maskAtom } from "../Data/Atoms";

interface MyIconProps {
    size?:        number;
    strokeWidth?: number;
}

interface MenuItemProps {
    icon:     React.ReactElement<MyIconProps>;
    to:       string;
    text:     string;
    default?: boolean;
    active?:  boolean;
    onClick?: (e: React.MouseEvent) => void;
}

export function MenuItem(props: MenuItemProps) {
    const navigate = useNavigate();
    const [, setMask] = useAtom(maskAtom);
    
    const iconWithProps = React.cloneElement<IconProps>(props.icon, {
        size: props.icon.props.size !== undefined ? 24 : props.icon.props.size,
    });

    const handleClick = (e: React.MouseEvent, isActive: boolean) => {
        // If custom onClick is provided, use it
        if (props.onClick) {
            e.preventDefault();
            props.onClick(e);
            return;
        }

        // Don't show loading mask if this menu item is active
        if (isActive) {
            e.preventDefault();
            return;
        }

        // Navigate to the new route
        navigate(props.to);
    };

    return <NavLink to={props.to}
                    onClick={(e) => {
                        // Get the active state from the NavLink's className
                        const isActive = e.currentTarget.className.includes('active');
                        handleClick(e, isActive);
                    }}
                    
                    className={({ isActive }) => `step-${props.text.toLocaleLowerCase()} facility-menu-item ${(isActive || props.active) ? "active" : ""}`}
                    end={props.default}>
        <div className="grid-col-2 align-self-center d-flex-align-center">
            {iconWithProps}
        </div>
        <div className="grid-col-4 align-self-center d-flex-align-center">
            {props.text}
        </div>
    </NavLink>;
}
